import { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Undo2 } from 'lucide-react';

import NewCouponService from '../../services/coupon-service';

import { useAuth } from '../../contexts/AuthContext';
import { showToast } from '../../components/ToastConfig';
import { STATUS_MESSAGES } from '../../utils/api-handlers/coupon-form';

function MemberSubscriptionDetails() {
  // const Navigate = useNavigate();
  // const { id } = useParams();
  // const [mode, setMode] = useState('create');
  // const [couponData, setCouponData] = useState(null);
  
  // const { logout } = useAuth();

  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors, isSubmitting },
  //   watch,
  //   setValue,
  //   reset,
  //   getValues
  // } = useForm({
  //   mode: 'onChange'
  // });

  // // 獲取優惠券資料
  // useEffect(() => {
  //   const fetchCouponData = async () => {
  //     if (!id || id === "new") {
  //       setMode('create');
  //       return;
  //     }

  //     try {
  //       setMode('edit');
  //       const data = await NewCouponService.getDetails(id);
  //       setCouponData(data.data);
  //       console.log("data:", data.data);
        
  //       // 設置表單預設值
  //       Object.keys(data.data).forEach(key => {
  //         if (key === 'validFrom' || key === 'validTo') {
  //           setValue(key, data.data[key].replaceAll("/", "-"));
  //         } else {
  //           setValue(key, data.data[key]);
  //         }
  //       });
  //     } catch (error) {
  //       console.error('Failed to fetch coupon data:', error);
  //       if (error?.response?.status === 401 || error?.response?.status === 403) {
  //         // showToast.error('無權訪問此頁面');
  //         // Navigate('/subscription/coupon');
  //         // return;
  //         logout();
  //       } else if (error?.response?.status === 400 && error?.response?.data?.errorCode === '2000') {
  //         Navigate('/coupon');
  //         return;
  //       } else {
  //         showToast.error('獲取優惠券資料失敗');
  //       }
  //     }
  //   };

  //   fetchCouponData();
  // }, [id, setValue, Navigate]);

  // const onSubmit = async (data) => {
  //   data.validFrom = data.validFrom.replaceAll("-", "/");
  //   data.validTo = data.validTo.replaceAll("-", "/");

  //   console.log("data", data);

  //   const { name, maxUsage, validFrom, validTo, isEnabled } = data;

  //   try {
  //     let res;
  //     if (mode === 'edit') {
  //       res = await NewCouponService.update(id, { name, maxUsage: Number(maxUsage), validFrom, validTo, isEnabled });
  //       showToast.success('優惠券更新成功');
  //     } else {
  //       res = await NewCouponService.create({ ...data, maxUsage: Number(maxUsage) });
  //       showToast.success('優惠券建立成功');
  //     }

  //     setTimeout(() => {
  //       Navigate('/coupon');
  //     }, 1000);
  //   } catch (error) {
  //     console.error('Form submission failed:', error);
  //     if (error?.response?.status === 401 || error?.response?.status === 403) {
  //       logout();
  //     } else if (error?.response?.status === 400) {
  //       showToast.error(STATUS_MESSAGES[error?.response?.data?.errorCode] || '提交失敗，請稍後再試');
  //     } else {
  //       showToast.error(error?.response?.data?.message || '提交失敗，請稍後再試');
  //     }
  //   }
  // };

  // // 檢查結束日期是否晚於開始日期
  // const validateDateRange = (endDate) => {
  //   const startDate = getValues("validFrom");
  //   if (!startDate || !endDate) return true; // 如果任一日期為空，不進行驗證
    
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);
    
  //   return end > start || "截止日必須晚於起始日";
  // };

  return (
    <div className="container mx-auto p-6">
      <p>內容頁面（建置中）</p>

      {/* <Link to="/subscription/coupon" className="text-blue-500 hover:text-blue-600 group flex items-center mb-5 w-fit p-3 -ml-3">
        <Undo2 size={36} className="text-blue-500 group-hover:text-blue-600 mr-1" />  
        <span className="font-bold">返回</span>
      </Link>

      <div className="mx-auto">
        <h1 className="text-2xl font-bold mb-6">
          {mode === 'edit' ? '編輯優惠券' : '新增優惠券'}
        </h1>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-1">
              <label className="block text-sm font-medium">
                名稱
              </label>
              <input
                {...register('name')}
                className={`w-full p-2 border rounded ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
              />
              {errors.name && (
                <p className="text-red-500 text-sm">{errors.name.message}</p>
              )}
            </div>

            <div className="space-y-1">
              <label className="block text-sm font-medium">
                可使用次數
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                {...register('maxUsage', { 
                  required: '可使用次數為必填欄位',
                  pattern: {
                    value: /^[0-9]*$/,
                    message: '請輸入數字'
                  },
                  min: {
                    value: 1,
                    message: '可使用次數最小為 1'
                  } 
                })}
                className={`w-full p-2 border rounded ${errors.maxUsage ? 'border-red-500' : 'border-gray-300'}`}
              />
              {errors.maxUsage && (
                <p className="text-red-500 text-sm">{errors.maxUsage.message}</p>
              )}
            </div>

            <div className="space-y-1">
              <label className="block text-sm font-medium">
                有效日期（起始日）
                <span className="text-red-500">*</span>
              </label>
              <input
                {...register('validFrom', { 
                  required: '有效日期（起始日）為必填欄位'
                })}
                type='date'
                className={`w-full p-2 border rounded ${errors.validFrom ? 'border-red-500' : 'border-gray-300'}`}
              />
              {errors.validFrom && (
                <p className="text-red-500 text-sm">{errors.validFrom.message}</p>
              )}
            </div>

            <div className="space-y-1">
              <label className="block text-sm font-medium">
                有效日期（截止日）
                <span className="text-red-500">*</span>
              </label>
              <input
                {...register('validTo', { 
                  required: '有效日期（截止日）為必填欄位',
                  validate: validateDateRange
                })}
                type='date'
                className={`w-full p-2 border rounded ${errors.validTo ? 'border-red-500' : 'border-gray-300'}`}
              />
              {errors.validTo && (
                <p className="text-red-500 text-sm">{errors.validTo.message}</p>
              )}
            </div>

            {mode === 'edit' && (
              <div className="space-y-1">
                <label className="block text-sm font-medium">優惠券代碼</label>
                <input
                  {...register('code')}
                  disabled
                  className="w-full p-2 border rounded border-gray-300 bg-gray-50"
                />
              </div>
            )}

            {mode === 'edit' && (
              <div className="space-y-1">
                <label className="block text-sm font-medium">建立時間</label>
                <input
                  {...register('createdAt')}
                  disabled
                  className="w-full p-2 border rounded border-gray-300 bg-gray-50"
                />
              </div>
            )}

            <div className="space-y-1 col-span-2">
              <label className="block text-sm font-medium mb-2">
                啟用狀態
                <span className="text-red-500 ml-1">*</span>
              </label>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => setValue('isEnabled', !watch('isEnabled'))}
                  className={`relative inline-flex h-9 w-[4.5rem] items-center rounded-full transition-colors duration-300 
                    ${watch('isEnabled') ? 'bg-green-600 bg-opacity-20' : 'bg-gray-200'}
                    hover:bg-opacity-30
                  `}
                >
                  <span
                    className={`inline-block h-7 w-7 transform rounded-full transition-transform duration-300 ${
                      watch('isEnabled') ? 'translate-x-9 bg-green-600' : 'translate-x-1 bg-gray-400'
                    }`}
                  />
                  <span 
                    className={`absolute ${
                      watch('isEnabled')
                        ? 'left-2.5 text-green-600'
                        : 'right-2.5 text-gray-500'
                    }`}
                  >
                    {watch('isEnabled') ? '是' : '否'}
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div className="flex justify-end mt-8">
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              disabled={isSubmitting}
            >
              {isSubmitting ? "提交中..." : "提交"}
            </button>
          </div>
        </form>

        {couponData?.usedMember?.length > 0 && (
          <div className='border-t border-gray-300 mt-10'>
            <div className='relative w-fit'>
              <h2 className='text-lg font-bold mt-6 text-blue-500'>優惠券使用紀錄</h2>
              <div className='absolute bottom-0 left-0 bg-blue-100 w-[calc(100%+1rem)] h-4 -z-10'></div>
            </div>
            <div className='mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'>
              {couponData.usedMember.map(member => (
                <div key={member.uuid} className='flex justify-between p-4 border rounded hover:bg-gray-50'>
                  <div className='gap-2'>
                    <p className='font-bold text-gray-700'>姓名：<span className='font-normal text-gray-500'>{member.name}</span></p>
                    <p className='font-bold text-gray-700'>Email：<span className='font-normal text-gray-500'>{member.email}</span></p>
                    <p className='font-bold text-gray-700'>公司：<span className='font-normal text-gray-500'>{member.company}</span></p>
                    <p className='font-bold text-gray-700'>職稱：<span className='font-normal text-gray-500'>{member.jobTitle}</span></p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div> */}
    </div>
  );
}

export default MemberSubscriptionDetails;